// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3QykL","name":"Header_name__1by_D","birthday":"Header_birthday__3Jahq","skeleton":"Header_skeleton__3ER4N"};